export default __webpack_public_path__ + "static/media/LogoAnimationsgGif.5c90a283.gif";